import DemoIcon3 from '../../../assets/icons/WebExperience_LeftNav-Icon3.svg';
import ReviewAccessIntroImage from '../../../assets/images/SailPoint-StaticImages_ReviewAccessUncorrelatedAccounts-Intro.png';
import ReviewAccessOutroImage from '../../../assets/images/SailPoint-StaticImages_ReviewAccessUncorrelatedAccounts-Outro.png';
import ReviewAccessUncorrelated from '../../../assets/images/walnut-screens/ReviewAccessForUncorrelatedAccounts-Walnut-Screen.png';
import PlusAnimation from '../../../assets/animations/SP-BusinessPlus-Animation-v1.0.mp4';
import SeparationOfDutiesIntroImage from '../../../assets/images/SailPoint_OutlierWorkflow-Intro.png';
import SeparationOfDutiesOutroImage from '../../../assets/images/SailPoint_OutlierWorkflow-Outro.png';
import SodIntro from '../../../assets/images/SailPoint_SOD-Intro.png';
import SodOutro from '../../../assets/images/SailPoint_SOD-Outro.png';
import HealthcareAccessManagementIntro from '../../../assets/images/Q2-2023-DEMOS/SailPoint_HealthcareAccessManagement-Intro.png';
import HealthcareAccessManagementOutro from '../../../assets/images/Q2-2023-DEMOS/SailPoint_HealthcareAccessManagement-Outro.png';
import NonEmployeeRiskManagementIntro from '../../../assets/images/Q2-2023-DEMOS/SailPoint_NonEmployeeRiskManagement-Intro.png';
import NonEmployeeRiskManagementOutro from '../../../assets/images/Q2-2023-DEMOS/SailPoint_NonEmployeeRiskManagement-Outro.png';
import TeamsIntegrationIntro from '../../../assets/images/Q2-2023-DEMOS/SailPoint_TeamsIntegration-Intro.png';
import TeamsIntegrationOutro from '../../../assets/images/Q2-2023-DEMOS/SailPoint_TeamsIntegration-Outro.png';
import WorkReassignmentIntro from '../../../assets/images/Q2-2023-DEMOS/SailPoint_WorkReassignment-Intro.png';
import WorkReassignmentOutro from '../../../assets/images/Q2-2023-DEMOS/SailPoint_WorkReassignment-Outro.png';

const data = {
  animation: PlusAnimation,
  intro: {
    title: 'Interactive Demos',
    businessHeading: 'See the Business solution in action',
    heading: 'See the solution in action',
    instruction: 'Select a demo to begin'
  },
  demos: [
    {
      id: 9,
      title: 'Review access for uncorrelated ',
      actionText: 'accounts',
      descriptionTitle: 'Review access for uncorrelated accounts',
      description: [
        `Gain a comprehensive view of all identities and access including accounts that from non-authoritative systems that are not mapped to an identity.`
      ],
      icon: DemoIcon3,
      illustration: ReviewAccessIntroImage,
      illustrationOutro: ReviewAccessOutroImage,
      outroTitle: 'Review access for uncorrelated accounts',
      outroDescription: [
        'Simplify achieving compliance mandates and automate the certification of uncorrelated accounts.'
      ],
      demoIdentifier: 'Review Access',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=bf2cff42-80aa-4ca5-971f-0f28c5e01329&showGuide=true&showGuidesToolbar=false&showHotspots=true&embedInDomain=&isEmbed=false',
      walnutPlaceholder: ReviewAccessUncorrelated
    },
    {
      id: 10,
      title: 'Identify Separation of Duties ',
      actionText: '(SOD) Conflicts',
      descriptionTitle: '(SOD) Conflicts',
      description: [
        `Learn how Access Risk Management allows you to rapidly identify SOD and sensitive access risks across your SAP systems.`
      ],
      icon: DemoIcon3,
      illustration: SodIntro,
      illustrationOutro: SodOutro,

      outroTitle: 'Identify Separation of Duties (SOD) Conflicts',
      outroDescription: [
        'Discover on-going risks by user, role, and business process — with actionable, business-ready intelligence.'
      ],
      demoIdentifier: 'Separation of Duties',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=93fe08a4-196c-404e-b032-45767d68dc03&sh[…]ue&showGuidesToolbar=true&showHotspots=true&source=app',
      walnutPlaceholder: SodOutro
    },
    {
      id: 11,
      title: 'Automate workflows ',
      actionText: 'for outliers',
      descriptionTitle: 'Automate workflows for outliers',
      description: [
        `Discover how to use Workflows to automate your identity security program and match the speed of modern business.`
      ],
      icon: DemoIcon3,
      illustration: SeparationOfDutiesIntroImage,
      illustrationOutro: SeparationOfDutiesOutroImage,
      outroTitle: 'Automate workflows for outliers',
      outroDescription: [
        'Based on the customized needs of your organization, multiple workflows can be created to automatically respond to different outlier scores.'
      ],
      demoIdentifier: 'Automate Workflows',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=403dce53-cc87-4839-8e06-4ec7eab075c1&sh[…]ue&showGuidesToolbar=true&showHotspots=true&source=app',
      walnutPlaceholder: SeparationOfDutiesIntroImage
    },
    {
      id: 12,
      title: 'Managing third-party',
      actionText: 'non-employee identities',
      descriptionTitle: 'Managing third-party non-employee identities',
      description: [`See how Non-Employee Risk Management helps you manage third-party non-employee identities.`],
      icon: DemoIcon3,
      illustration: HealthcareAccessManagementIntro,
      illustrationOutro: HealthcareAccessManagementOutro,
      outroTitle: 'Managing third-party non-employee identities',
      outroDescription: ['Extend the value of your identity security program with Non-Employee Risk Management!'],
      demoIdentifier: 'Managing Third-party',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=1bf1412b-9cba-4e3c-8e56-fb47db6bd57d&showGuide=true&showGuidesToolbar=true&showHotspots=true&source=app',
      walnutPlaceholder: HealthcareAccessManagementIntro
    },
    {
      id: 13,
      title: 'Work ',
      actionText: 'reassignment',
      descriptionTitle: 'Work reassignment',
      description: [`Learn how to reassign tasks automatically for you, your team, or on behalf of a user.`],
      icon: DemoIcon3,
      illustration: WorkReassignmentIntro,
      illustrationOutro: WorkReassignmentOutro,
      outroTitle: 'Work reassignment',
      outroDescription: [
        'Keep your SailPoint IdentityNow solution operating smoothly by automatically reassigning tasks.'
      ],
      demoIdentifier: 'Work Reassignment',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=46378b86-ddc4-4849-9bae-62e237b360f1&showGuide=true&showGuidesToolbar=true&showHotspots=true&source=app',
      walnutPlaceholder: WorkReassignmentIntro
    },

    {
      id: 14,
      title: 'Integrate with  ',
      actionText: 'Microsoft Teams',
      descriptionTitle: 'Integrate with Microsoft Teams',
      description: [
        `The SailPoint and Microsoft Teams integration empowers workers to easily make, approve, or deny access requests – all from within the Teams collaboration tool.`
      ],
      icon: DemoIcon3,
      illustration: TeamsIntegrationIntro,
      illustrationOutro: TeamsIntegrationOutro,
      outroTitle: 'Integrate with Microsoft Teams',
      outroDescription: [
        'By incorporating identity into the Team’s collaboration workspace, users get the access they need – efficiently and securely. The Teams integration can be set up in just minutes to accelerate access delivery and reduce manual IT requests.'
      ],
      demoIdentifier: 'Integrate With Mirosoft Teams',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=59046adc-a4a7-4279-a889-eff9e60a3fe0&showGuide=true&showGuidesToolbar=false&showHotspots=true&source=app',
      walnutPlaceholder: TeamsIntegrationIntro
    },
    {
      id: 15,
      title: 'New healthcare employee ',
      actionText: 'access request ',
      descriptionTitle: 'New healthcare employee access request',
      description: [
        `See how the IdentityNow Request Center streamlines the process of requesting access for yourself, your team, or anyone in your healthcare organization.`
      ],
      icon: DemoIcon3,
      illustration: NonEmployeeRiskManagementIntro,
      illustrationOutro: NonEmployeeRiskManagementOutro,
      outroTitle: 'New healthcare employee access request',
      outroDescription: [
        `Accelerate secure healthcare access for clinicians and other healthcare staff with a frictionless experience.`
      ],
      demoIdentifier: 'New Healthcare Employee',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=01b4214b-66ea-4321-a857-ff4a4ef39a16&showGuide=true&showGuidesToolbar=true&showHotspots=true&source=app',
      walnutPlaceholder: NonEmployeeRiskManagementIntro
    }
  ]
};

export default data;
